import { SVGAssets } from '@business/assets/vectors';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { Button } from '../Button';

interface SelectFriendFamilyProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (type: 'family' | 'friend') => void;
  personName?: string;
}

export const SelectFriendFamily = ({
  isOpen,
  onClose,
  onConfirm,
  personName
}: SelectFriendFamilyProps) => {
  const { t } = useTranslation();
  const [selectedType, setSelectedType] = useState<'family' | 'friend' | null>(
    null
  );

  if (!isOpen) return null;

  const handleConfirm = () => {
    if (selectedType) {
      onConfirm(selectedType);
      setSelectedType(null);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-[70]">
      <div className="bg-white rounded-2xl shadow-xl w-full max-w-md p-6 relative animate-fadeIn confirmation-box-style">
        <Button
          btnStyle="link"
          className="absolute right-4 top-4"
          onClick={() => {
            setSelectedType(null);
            onClose();
          }}>
          <SVGAssets.CloseIconGray className="w-4 h-4" />
        </Button>

        {/* Header */}
        <div className="mb-6 mt-3">
          <h2 className="text-xl font-semibold text-gray-800">
            {t('people.selectRelationship', {
              defaultValue: `Is ${personName || 'this person'} a family member or a friend`
            })}
          </h2>
        </div>

        {/* Options */}
        <div className="grid grid-cols-2 gap-4 mb-6">
          <button
            onClick={() => setSelectedType('family')}
            className={`px-6 py-4 rounded-lg border-2 transition-all font-medium ${
              selectedType === 'family'
                ? 'border-[#7F9D48] bg-[#7F9D48]/10 text-[#7F9D48]'
                : 'border-gray-300 bg-white text-gray-700 hover:border-gray-400'
            }`}>
            {t('people.family', { defaultValue: 'Family' })}
          </button>
          <button
            onClick={() => setSelectedType('friend')}
            className={`px-6 py-4 rounded-lg border-2 transition-all font-medium ${
              selectedType === 'friend'
                ? 'border-[#7F9D48] bg-[#7F9D48]/10 text-[#7F9D48]'
                : 'border-gray-300 bg-white text-gray-700 hover:border-gray-400'
            }`}>
            {t('people.friend', { defaultValue: 'Friend' })}
          </button>
        </div>

        {/* Confirm Button */}
        <Button
          onClick={handleConfirm}
          disabled={!selectedType}
          btnStyle="primary"
          className="w-full py-3 rounded-lg font-semibold text-white disabled:opacity-50 disabled:cursor-not-allowed">
          {t('confirm', { defaultValue: 'Confirm' })}
        </Button>
      </div>
    </div>
  );
};
